import { useQuery, useQueryClient } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';
import { API_URL } from '@/config';

export const getProjectContent = async ({
  folder_id,
  file_id,
  projectId,
}: {
  folder_id?: any;
  file_id?: string;
  projectId: any;
}): Promise<any> => {
  try {
    if (projectId) {
      const randomValue = Math.floor(1000 + Math.random() * 9000);

      const response = await axios.get(
        folder_id?.length > 0
          ? `${API_URL}/v2/project/${projectId}/contents?folder_id=${folder_id}&a=${randomValue}`
          : file_id && file_id.length > 0
          ? `${API_URL}/v2/project/${projectId}/contents?file_id=${file_id}&a=${randomValue}`
          : `${API_URL}/v2/project/${projectId}/contents?a=${randomValue}`
      );
      return response?.data;
    }
  } catch (error) {
    // console.error('Error getProjectContent:', error);
    // throw error;
  }
};

export const useGetProjectContent = (projectId: any, folder_id?: any, config = {}) => {
  const queryClient = useQueryClient();
  const { addNotification } = useNotificationStore();

  const query = useQuery<any, Error>(
    ['projectContent', projectId, folder_id],
    () => getProjectContent({ projectId, folder_id }),
    {
      onError: (error) => {
        addNotification({
          type: 'error',
          title: 'Failed to fetch project content',
          message: error.message,
        });
      },
      onSuccess: () => {},
      ...config,
    }
  );

  const invalidateRepoContent = async () => {
    await queryClient.invalidateQueries(['projectContent', projectId]);
    // Also invalidate any folder-specific queries for this project
    await queryClient.invalidateQueries(['projectContent', projectId, folder_id]);
  };

  return { ...query, invalidateRepoContent };
};

export const invalidateRepoContent = async (
  projectId: any,
  queryClient: ReturnType<typeof useQueryClient>
) => {
  // Invalidate all projectContent queries for this project
  await queryClient.invalidateQueries(['projectContent', projectId]);
  // Invalidate all folder-specific queries for this project using query key pattern
  await queryClient.invalidateQueries({
    predicate: (query) => {
      const queryKey = query.queryKey as any[];
      return queryKey[0] === 'projectContent' && queryKey[1] === projectId;
    },
  });
};
